import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardContent,
  TextField,
  MenuItem,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import crecheApi from '../../services/crecheApi';
import MatriculaWizard from './components/MatriculaWizard';

export default function NovaMatriculaCrechePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [estudantes, setEstudantes] = useState([]);
  const [form, setForm] = useState({
    estudanteId: '',
    grupoId: '',
    dataInicio: '',
    planoCrecheId: '',
  });
  const [matriculaCriada, setMatriculaCriada] = useState(null);
  const [erro, setErro] = useState(null);

  // 🔹 Carregar grupos e estudantes disponíveis
  useEffect(() => {
    const carregarDados = async () => {
      try {
        setLoading(true);
        const [respGrupos, respEstudantes] = await Promise.all([
          crecheApi.listarGrupos?.() ?? [],
          crecheApi.listarEstudantes?.() ?? [],
        ]);
        setGrupos(respGrupos?.data || []);
        setEstudantes(respEstudantes?.data || []);
      } catch (err) {
        console.error(err);
        setErro('Erro ao carregar dados iniciais.');
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.estudanteId || !form.grupoId || !form.dataInicio) {
      toast.warn('Preencha todos os campos obrigatórios.');
      return;
    }

    try {
      setLoading(true);
      const { data } = await crecheApi.criarMatricula(form);
      toast.success('Matrícula criada com sucesso!');
      setMatriculaCriada(data.matricula);
    } catch (err) {
      console.error(err);
      toast.error('Erro ao criar matrícula.');
      setErro(err.response?.data?.erro || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleConcluir = () => {
    toast.success('Matrícula ativada com sucesso!');
    navigate('/creche/matriculas');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} mb={3}>
        Nova Matrícula na Creche
      </Typography>

      {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

      {!matriculaCriada ? (
        <Card sx={{ maxWidth: 800 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Estudante"
                  name="estudanteId"
                  value={form.estudanteId}
                  onChange={handleChange}
                  required
                >
                  {estudantes.map((e) => (
                    <MenuItem key={e.id} value={e.id}>
                      {e.nome}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Grupo"
                  name="grupoId"
                  value={form.grupoId}
                  onChange={handleChange}
                  required
                >
                  {grupos.map((g) => (
                    <MenuItem key={g.id} value={g.id}>
                      {g.nome}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  type="date"
                  fullWidth
                  label="Data de Início"
                  name="dataInicio"
                  InputLabelProps={{ shrink: true }}
                  value={form.dataInicio}
                  onChange={handleChange}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={24} /> : 'Criar Matrícula'}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ) : (
        <Box>
          <MatriculaWizard matricula={matriculaCriada} />
          <Box sx={{ mt: 3, textAlign: 'right' }}>
            <Button
              variant="contained"
              color="success"
              onClick={handleConcluir}
            >
              Concluir / Ativar Matrícula
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
